import { render, staticRenderFns } from "./RHorizontalRule.vue?vue&type=template&id=540dacdd&scoped=true"
import script from "./RHorizontalRule.vue?vue&type=script&lang=js"
export * from "./RHorizontalRule.vue?vue&type=script&lang=js"
import style0 from "./RHorizontalRule.vue?vue&type=style&index=0&id=540dacdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540dacdd",
  null
  
)

export default component.exports